export default "__VITE_ASSET__BDvv7jIF__"